
import { Pie, mixins } from 'vue-chartjs';
// Optional: Import plugins if you need them globally registered here,
// but it's often better to register them in main.js or within the component using them.
// import ChartDataLabels from 'chartjs-plugin-datalabels';
// import { Chart } from 'chart.js';
// Chart.register(ChartDataLabels);

const { reactiveProp } = mixins;

export default {
  name: 'PieChart',
  extends: Pie, // Extend the Pie chart component from vue-chartjs
  mixins: [reactiveProp], // Use the mixin for automatic updates
  props: {
    // chartData is handled by the reactiveProp mixin
    // It expects an object with labels and datasets arrays
    options: {
      type: Object,
      required: true,
      default: () => {}, // Provide a default empty object or function returning one
    },
    // You can add other standard vue-chartjs props if needed
    height: {
        type: Number,
        default: 300 // Default height, can be overridden
    },
    width: {
        type: Number,
        // Default is responsive, so usually not needed unless fixed size
    },
    cssClasses: {
        type: String,
        default: ''
    },
    styles: {
        type: Object,
        default: () => {}
    },
    plugins: {
        type: Array,
        default: () => [] // Array for chart plugins if needed
    }
  },
  mounted () {
    // this.chartData is created in the mixin.
    // If you want to pass options, plugins and render the chart manually.
    // this.renderChart(this.chartData, this.options);

    // The reactiveProp mixin handles the initial render and updates automatically.
    // It essentially calls this.renderChart(this.chartData, this.options)
    // If you need to add plugins specifically here, you might do it before rendering:
    // this.addPlugin(YourPlugin); // Example if adding plugins directly
    console.log("PieChart mounted. Chart Data:", this.chartData);
    this.renderChart(this.chartData, this.options); // Render the chart with the data and options passed as props
  },
  // Optional: Watch for options changes if they need to trigger re-renders
  // The reactiveProp mixin only watches chartData by default.
//   watch: {
//     options: {
//       handler(newOptions) {
//         if (this._chart) { // Check if chart instance exists
//             this._chart.destroy(); // Destroy old chart
//         }
//         this.renderChart(this.chartData, newOptions); // Re-render with new options
//       },
//       deep: true
//     }
//   }
}
